import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryExportUrl = createRoutine(
  'FETCH_INVENTORY_EXPORT_URL'
);
